export function listQueryKey(resource, listQuery) {
  return ['erp', resource, 'list', listQuery];
}

export function listQueryKeyPrefix(resource) {
  return ['erp', resource, 'list'];
}

export function mtrStructMainListQueryKey(listQuery) {
  return ['erp', 'mtrStructMain', 'list', listQuery];
}

export function mtrStructMainListQueryKeyPrefix() {
  return ['erp', 'mtrStructMain', 'list'];
}

export function mtrStructMainDetailQueryKey(id) {
  return ['erp', 'mtrStructMain', 'detail', id];
}

export function mtrStructSubListQueryKey(listQuery) {
  return ['erp', 'mtrStructSub', 'list', listQuery];
}

export function mtrStructSubListQueryKeyPrefix() {
  return ['erp', 'mtrStructSub', 'list'];
}

export function mtrStructSubDetailQueryKey(id) {
  return ['erp', 'mtrStructSub', 'detail', id];
}

export function mtrSpecListQueryKey(listQuery) {
  return ['erp', 'mtrSpec', 'list', listQuery];
}

export function mtrSpecListQueryKeyPrefix() {
  return ['erp', 'mtrSpec', 'list'];
}

export function mtrSpecDetailQueryKey(id) {
  return ['erp', 'mtrSpec', 'detail', id];
}

export function manufacturerListQueryKey(listQuery) {
  return ['erp', 'manufacturer', 'list', listQuery];
}

export function manufacturerListQueryKeyPrefix() {
  return ['erp', 'manufacturer', 'list'];
}

export function manufacturerDetailQueryKey(id) {
  return ['erp', 'manufacturer', 'detail', id];
}

export function inspectionKindListQueryKey() {
  return ['erp', 'inspectionKind', 'list'];
}

export function inspectionKindListQueryKeyPrefix() {
  return ['erp', 'inspectionKind', 'list'];
}

export function inspectionKindDetailQueryKey(id) {
  return ['erp', 'inspectionKind', 'detail', id];
}

export function inspectionKindRevisionQueryKey(id, revisionNo) {
  return ['erp', 'inspectionKind', 'revision', id, String(revisionNo)];
}

export function supplierListQueryKey(listQuery) {
  return ['erp', 'supplier', 'list', listQuery];
}

export function supplierListQueryKeyPrefix() {
  return ['erp', 'supplier', 'list'];
}

export function supplierDetailQueryKey(id) {
  return ['erp', 'supplier', 'detail', id];
}

export function stockIssueCategoryListQueryKey(listQuery) {
  return ['erp', 'stockIssueCategory', 'list', listQuery];
}

export function stockIssueCategoryListQueryKeyPrefix() {
  return ['erp', 'stockIssueCategory', 'list'];
}

export function stockIssueCategoryDetailQueryKey(id) {
  return ['erp', 'stockIssueCategory', 'detail', id];
}

export function mtrStructTreeQueryKey(params = { status: 'ACTIVE' }) {
  return ['erp', 'mtrStruct', 'tree', params];
}

export function mtrTemplateListQueryKey(listQuery) {
  return ['erp', 'mtrTemplate', 'list', listQuery];
}

export function mtrTemplateListQueryKeyPrefix() {
  return ['erp', 'mtrTemplate', 'list'];
}

export function mtrTemplateDetailQueryKey(id) {
  return ['erp', 'mtrTemplate', 'detail', id];
}

export function mtrListQueryKey(listQuery) {
  return ['erp', 'mtr', 'list', listQuery];
}

export function mtrListQueryKeyPrefix() {
  return ['erp', 'mtr', 'list'];
}

export function mtrDetailQueryKey(id) {
  return ['erp', 'mtr', 'detail', id];
}

export function mtrSnMappingsQueryKey(mtrId) {
  return ['erp', 'mtr', 'snMappings', mtrId];
}

export function mtrUnitListQueryKey(mtrId) {
  return ['erp', 'mtr', mtrId, 'units'];
}

export function inventoryStockListQueryKey(listQuery) {
  return ['erp', 'inventoryStock', 'list', listQuery];
}

export function inventoryStockListQueryKeyPrefix() {
  return ['erp', 'inventoryStock', 'list'];
}

export function inventorySafetyCheckQueryKey(listQuery) {
  return ['erp', 'inventoryStock', 'safetyCheck', listQuery];
}

export function warehouseListQueryKey(listQuery) {
  return ['erp', 'warehouse', 'list', listQuery];
}

export function warehouseListQueryKeyPrefix() {
  return ['erp', 'warehouse', 'list'];
}

export function warehouseDetailQueryKey(id) {
  return ['erp', 'warehouse', 'detail', id];
}

export function warehouseLocationListQueryKey(listQuery) {
  return ['erp', 'warehouseLocation', 'list', listQuery];
}

export function warehouseLocationListQueryKeyPrefix() {
  return ['erp', 'warehouseLocation', 'list'];
}

export function warehouseLocationDetailQueryKey(id) {
  return ['erp', 'warehouseLocation', 'detail', id];
}

export function stockReceiptListQueryKey(listQuery) {
  return ['erp', 'stockReceipt', 'list', listQuery];
}

export function stockReceiptListQueryKeyPrefix() {
  return ['erp', 'stockReceipt', 'list'];
}

export function stockReceiptDetailQueryKey(id) {
  return ['erp', 'stockReceipt', 'detail', id];
}

export function stockTransferListQueryKey(listQuery) {
  return ['erp', 'stockTransfer', 'list', listQuery];
}

export function stockTransferListQueryKeyPrefix() {
  return ['erp', 'stockTransfer', 'list'];
}

export function stockTransferDetailQueryKey(id) {
  return ['erp', 'stockTransfer', 'detail', id];
}

export function stockIssueListQueryKey(listQuery) {
  return ['erp', 'stockIssue', 'list', listQuery];
}

export function stockIssueListQueryKeyPrefix() {
  return ['erp', 'stockIssue', 'list'];
}

export function stockIssueDetailQueryKey(id) {
  return ['erp', 'stockIssue', 'detail', id];
}

export function stockAdjustmentListQueryKey(listQuery) {
  return ['erp', 'stockAdjustment', 'list', listQuery];
}

export function stockAdjustmentListQueryKeyPrefix() {
  return ['erp', 'stockAdjustment', 'list'];
}

export function stockAdjustmentDetailQueryKey(id) {
  return ['erp', 'stockAdjustment', 'detail', id];
}

export function stockReturnListQueryKey(listQuery) {
  return ['erp', 'stockReturn', 'list', listQuery];
}

export function stockReturnListQueryKeyPrefix() {
  return ['erp', 'stockReturn', 'list'];
}

export function stockReturnDetailQueryKey(id) {
  return ['erp', 'stockReturn', 'detail', id];
}

export function stockReturnWorkWarehouseSourcesQueryKey(listQuery) {
  return ['erp', 'stockReturn', 'workWarehouseSources', listQuery];
}

export function stockReturnWorkWarehouseSourcesQueryKeyPrefix() {
  return ['erp', 'stockReturn', 'workWarehouseSources'];
}

export function stockReturnPendingAllocationListQueryKey(listQuery) {
  return ['erp', 'stockReturn', 'pendingAllocation', 'list', listQuery];
}

export function stockReturnPendingAllocationListQueryKeyPrefix() {
  return ['erp', 'stockReturn', 'pendingAllocation', 'list'];
}

export function stockReturnAmendmentListQueryKey(stockReturnId, listQuery) {
  return ['erp', 'stockReturn', 'amendment', 'list', stockReturnId, listQuery];
}

export function stockReturnAmendmentListQueryKeyPrefix(stockReturnId) {
  return ['erp', 'stockReturn', 'amendment', 'list', stockReturnId];
}

export function stockReturnAmendmentDetailQueryKey(stockReturnId, amendmentId) {
  return ['erp', 'stockReturn', 'amendment', 'detail', stockReturnId, amendmentId];
}

export function stocktakeListQueryKey(listQuery) {
  return ['erp', 'stocktake', 'list', listQuery];
}

export function stocktakeListQueryKeyPrefix() {
  return ['erp', 'stocktake', 'list'];
}

export function stocktakeDetailQueryKey(id) {
  return ['erp', 'stocktake', 'detail', id];
}

export function stocktakeComparisonQueryKey(listQuery) {
  return ['erp', 'stocktake', 'comparison', listQuery];
}

export function stocktakeComparisonQueryKeyPrefix() {
  return ['erp', 'stocktake', 'comparison'];
}

export function bomListQueryKey(listQuery) {
  return ['erp', 'bom', 'list', listQuery];
}

export function bomListQueryKeyPrefix() {
  return ['erp', 'bom', 'list'];
}

export function bomDetailQueryKey(id) {
  return ['erp', 'bom', 'detail', id];
}

export function processingFactoryListQueryKey(listQuery) {
  return ['erp', 'processingFactory', 'list', listQuery];
}

export function processingFactoryListQueryKeyPrefix() {
  return ['erp', 'processingFactory', 'list'];
}

export function processingFactoryDetailQueryKey(id) {
  return ['erp', 'processingFactory', 'detail', id];
}

export function workOrderListQueryKey(listQuery) {
  return ['erp', 'workOrder', 'list', listQuery];
}

export function workOrderListQueryKeyPrefix() {
  return ['erp', 'workOrder', 'list'];
}

export function workOrderDetailQueryKey(id) {
  return ['erp', 'workOrder', 'detail', id];
}

export function workOrderMaterialCandidatesQueryKey(listQuery) {
  return ['erp', 'workOrder', 'materialCandidates', listQuery];
}

export function workOrderManufacturingCommandStatusQueryKey(listQuery = {}) {
  return ['erp', 'workOrder', 'manufacturingCommandStatus', listQuery];
}

export function workOrderMaterialAnalysisQueryKey(listQuery = {}) {
  return ['erp', 'workOrder', 'materialAnalysis', listQuery];
}

export function workOrderMaterialAnalysisWorkOrdersQueryKey(listQuery) {
  return ['erp', 'workOrder', 'materialAnalysisWorkOrders', listQuery];
}

export function workOrderMaterialAnalysisWorkOrderQueryKey(id) {
  return ['erp', 'workOrder', 'materialAnalysisWorkOrder', id];
}

export function workOrderMaterialAnalysisMaterialsQueryKey(listQuery) {
  return ['erp', 'workOrder', 'materialAnalysisMaterials', listQuery];
}

export function workOrderMaterialAnalysisInTransitPurchaseOrdersQueryKey(
  listQuery,
) {
  return ['erp', 'workOrder', 'materialAnalysisInTransitPurchaseOrders', listQuery];
}

export function workOrderWorkWarehouseShortageQueryKey(params) {
  return ['erp', 'workOrder', 'workWarehouseShortage', params];
}

/** @deprecated 請改用 {@link workOrderWorkWarehouseShortageQueryKey} */
export function workOrderMaterialDemandQueryKey(params) {
  return workOrderWorkWarehouseShortageQueryKey(params);
}

export function workOrderMaterialShortageQueryKey(workWarehouseIds = []) {
  return ['erp', 'workOrder', 'materialShortage', { workWarehouseIds }];
}

export function workOrderStockIssueCandidatesQueryKey(id) {
  return ['erp', 'workOrder', 'stockIssueCandidates', id];
}

export function workOrderStockTransferCandidatesQueryKey(params) {
  return ['erp', 'workOrder', 'stockTransfer', 'candidates', params];
}

export function workOrderStockTransferListQueryKey(listQuery) {
  return ['erp', 'workOrder', 'stockTransfer', 'list', listQuery];
}

export function workOrderStockTransferListQueryKeyPrefix() {
  return ['erp', 'workOrder', 'stockTransfer', 'list'];
}

export function workOrderStockTransferDetailQueryKey(id) {
  return ['erp', 'workOrder', 'stockTransfer', 'detail', id];
}

export function workOrderAmendmentListQueryKey(workOrderId, listQuery) {
  return ['erp', 'workOrder', 'amendment', 'list', workOrderId, listQuery];
}

export function workOrderAmendmentListQueryKeyPrefix(workOrderId) {
  return ['erp', 'workOrder', 'amendment', 'list', workOrderId];
}

export function workOrderAmendmentDetailQueryKey(workOrderId, amendmentId) {
  return ['erp', 'workOrder', 'amendment', 'detail', workOrderId, amendmentId];
}

export function detailQueryKey(resource, id) {
  return ['erp', resource, 'detail', id];
}

export function lookupQueryKey(resource, params = {}) {
  return ['erp', resource, 'lookup', params];
}

/** system select 慣例（對齊 unit）：`lookupQueryKey('unitSelect'|'currencySelect'|'paymentTermSelect')` */

// --- CRM Customer ---

export function customerListQueryKey(listQuery) {
  return ['erp', 'customer', 'list', listQuery];
}

export function customerListQueryKeyPrefix() {
  return ['erp', 'customer', 'list'];
}

export function customerDetailQueryKey(id) {
  return ['erp', 'customer', 'detail', id];
}

// --- CRM Product ---

export function productListQueryKey(listQuery) {
  return ['erp', 'product', 'list', listQuery];
}

export function productListQueryKeyPrefix() {
  return ['erp', 'product', 'list'];
}

export function productDetailQueryKey(id) {
  return ['erp', 'product', 'detail', id];
}

// --- CRM Customer Order ---

export function customerOrderListQueryKey(listQuery) {
  return ['erp', 'customerOrder', 'list', listQuery];
}

export function customerOrderListQueryKeyPrefix() {
  return ['erp', 'customerOrder', 'list'];
}

export function customerOrderDetailQueryKey(id) {
  return ['erp', 'customerOrder', 'detail', id];
}

// --- CRM Quotation ---

export function quotationListQueryKey(listQuery) {
  return ['erp', 'quotation', 'list', listQuery];
}

export function quotationListQueryKeyPrefix() {
  return ['erp', 'quotation', 'list'];
}

export function quotationDetailQueryKey(id) {
  return ['erp', 'quotation', 'detail', id];
}

// --- CRM Cost Estimate ---

export function costEstimateListQueryKey(listQuery) {
  return ['erp', 'costEstimate', 'list', listQuery];
}

export function costEstimateListQueryKeyPrefix() {
  return ['erp', 'costEstimate', 'list'];
}

export function costEstimateDetailQueryKey(id) {
  return ['erp', 'costEstimate', 'detail', id];
}

// --- CRM Aftersales / Repair Request ---

export function repairRequestListQueryKey(listQuery) {
  return ['erp', 'repairRequest', 'list', listQuery];
}

export function repairRequestListQueryKeyPrefix() {
  return ['erp', 'repairRequest', 'list'];
}

export function repairRequestDetailQueryKey(id) {
  return ['erp', 'repairRequest', 'detail', id];
}

// --- CRM Aftersales / Repair Report ---

export function repairReportListQueryKey(listQuery) {
  return ['erp', 'repairReport', 'list', listQuery];
}

export function repairReportListQueryKeyPrefix() {
  return ['erp', 'repairReport', 'list'];
}

export function repairReportDetailQueryKey(id) {
  return ['erp', 'repairReport', 'detail', id];
}

// --- CRM Aftersales / Sign Receipt ---

export function signReceiptListQueryKey(listQuery) {
  return ['erp', 'signReceipt', 'list', listQuery];
}

export function signReceiptListQueryKeyPrefix() {
  return ['erp', 'signReceipt', 'list'];
}

export function signReceiptDetailQueryKey(id) {
  return ['erp', 'signReceipt', 'detail', id];
}

// --- Aftersales / SN Product Mapping ---

export function snProductMappingListQueryKey(listQuery) {
  return ['erp', 'snProductMapping', 'list', listQuery];
}

export function snProductMappingListQueryKeyPrefix() {
  return ['erp', 'snProductMapping', 'list'];
}

export function snProductMappingDetailQueryKey(id) {
  return ['erp', 'snProductMapping', 'detail', id];
}

export function snProductMappingInspectionKindsQueryKey(id) {
  return ['erp', 'snProductMapping', 'inspectionKinds', id];
}

export function repairItemListQueryKey(listQuery) {
  return ['erp', 'repairItem', 'list', listQuery];
}

export function repairItemListQueryKeyPrefix() {
  return ['erp', 'repairItem', 'list'];
}

export function repairItemDetailQueryKey(id) {
  return ['erp', 'repairItem', 'detail', id];
}

// --- CRM Sales Order ---

export {
  salesOrderListQueryKey,
  salesOrderListQueryKeyPrefix,
  salesOrderDetailQueryKey,
  salesOrderInventoryCandidatesQueryKey,
  salesOrderSnCandidatesQueryKey,
} from '#/api/crmMgmt/salesOrder/queryKeys';

// --- SRM Purchase Order ---

export function purchaseOrderListQueryKey(listQuery) {
  return ['erp', 'purchaseOrder', 'list', listQuery];
}

export function purchaseOrderListQueryKeyPrefix() {
  return ['erp', 'purchaseOrder', 'list'];
}

export function purchaseOrderDetailQueryKey(id) {
  return ['erp', 'purchaseOrder', 'detail', id];
}

/** `kind`：`purchaseOrder`｜`miscPurchaseOrder` */
export function purchaseAmendmentDetailQueryKey(kind, orderId, amendmentId) {
  return ['erp', kind, 'amendment', 'detail', orderId, amendmentId];
}

export function purchaseAmendmentQueryKeyPrefix(kind, orderId) {
  return ['erp', kind, 'amendment', 'detail', orderId];
}

export function purchasePaymentPlanQueryKey(kind, orderId) {
  return ['erp', kind, 'paymentPlan', orderId];
}

export function purchasePaymentRecordsQueryKey(accountId) {
  return ['erp', 'purchasePayment', 'records', accountId];
}

export function miscPurchaseOrderListQueryKey(listQuery) {
  return ['erp', 'miscPurchaseOrder', 'list', listQuery];
}

export function miscPurchaseOrderListQueryKeyPrefix() {
  return ['erp', 'miscPurchaseOrder', 'list'];
}

export function miscPurchaseOrderDetailQueryKey(id) {
  return ['erp', 'miscPurchaseOrder', 'detail', id];
}

export function purchaseOrderStockReceiptListQueryKey(poId, listQuery) {
  return ['erp', 'purchaseOrder', 'stockReceipt', 'list', poId, listQuery];
}

export function purchaseOrderStockReceiptListQueryKeyPrefix(poId) {
  return ['erp', 'purchaseOrder', 'stockReceipt', 'list', poId];
}

export function purchaseOrderStockReceiptDetailQueryKey(poId, receiptId) {
  return ['erp', 'purchaseOrder', 'stockReceipt', 'detail', poId, receiptId];
}

export function purchaseOrderArrivalScheduleListQueryKey(poId, listQuery) {
  return ['erp', 'purchaseOrder', 'arrivalSchedule', 'list', poId, listQuery];
}

export function purchaseOrderArrivalScheduleListQueryKeyPrefix(poId) {
  return ['erp', 'purchaseOrder', 'arrivalSchedule', 'list', poId];
}

export function purchaseOrderArrivalScheduleDetailQueryKey(poId, scheduleId) {
  return [
    'erp', 'purchaseOrder', 'arrivalSchedule', 'detail', poId, scheduleId,
  ];
}

// --- FMS voucher / payment-request（個人中心） ---

/** scope：'all'（`.read`）／'self'（`.self`），兩邊資料不同，cache 分開 */
export function voucherListQueryKey(listQuery, scope = 'all') {
  return ['erp', 'fms', 'voucher', 'list', scope, listQuery];
}

export function voucherListQueryKeyPrefix() {
  return ['erp', 'fms', 'voucher', 'list'];
}

export function voucherDetailQueryKey(id, scope) {
  return scope
    ? ['erp', 'fms', 'voucher', 'detail', id, scope]
    : ['erp', 'fms', 'voucher', 'detail', id];
}

export function voucherAttachmentListQueryKey(voucherId, listQuery) {
  return ['erp', 'fms', 'voucher', 'attachments', voucherId, listQuery];
}

export function paymentRequestListQueryKey(listQuery, scope = 'all') {
  return ['erp', 'fms', 'paymentRequest', 'list', scope, listQuery];
}

export function paymentRequestListQueryKeyPrefix() {
  return ['erp', 'fms', 'paymentRequest', 'list'];
}

/** 由請款單讀取的關聯憑證明細 */
export function paymentRequestVoucherDetailQueryKey(id, voucherId) {
  return ['erp', 'fms', 'paymentRequest', 'detail', id, 'voucher', voucherId];
}

export function paymentRequestDetailQueryKey(id, scope) {
  return scope
    ? ['erp', 'fms', 'paymentRequest', 'detail', id, scope]
    : ['erp', 'fms', 'paymentRequest', 'detail', id];
}
